import { Component } from '@angular/core';
import {TenantsService} from "../tenants.service";
import {ViewManagerService} from "../../../services/view-manager.service";
import {User} from "../../../model/tenants.model";

@Component({
  selector: 'admin-tenants-manage',
  templateUrl: './manage.component.html',
  styleUrls: ['./manage.component.css']
})
export class AdminTenantsManageComponent {

  constructor(
    private tenantsService: TenantsService,
    private viewManager: ViewManagerService
  ) {
  }

  manageUser(user: User) {

  }

  deleteUser(user: User) {

  }

  saveSpace() {

  }

  deleteSpace() {

  }

  getSpace() {
    return this.tenantsService.space;
  }

  getUsers() {
    return this.tenantsService.users;
  }

}
